import {isAuthenticated} from "./auth";

const API = process.env.REACT_APP_API_URL;

export const billValidate = (body) =>
{
    console.log("API: " + API);

    return fetch(`${API}/bill/search`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }).then(response =>
    {
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
}

export const billValidateLottery = (body) =>
{
    return fetch(`${API}/bill/search`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }).then(response =>
    {
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
}

//TODO: WORK ON THIS FOR WEB AND MOBILE +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// export const transactionHistory = () => {
//     return fetch(`${API}/transaction/history`, {
//         method: 'GET',
//         headers: {
//             Accept: 'application/json',
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${isAuthenticated()}`,
//         },
//     }).then(response => {
//         return response.json();
//     }).catch(err => {
//         console.log(err);
//     });
// }

export const transactionHistory = (body) =>
{
    // console.log("txn History: " + JSON.stringify(body));

    return fetch(`${API}/web/transaction-history`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${isAuthenticated()}`,
        },
        body: JSON.stringify(body),
    }).then(response =>
    {
        return response.json();
    }).catch(err =>
    {
        console.log(err);
    });
}